import { Chip, Tooltip } from '@ds';
import { ConditionalRender } from '@ui';
import { SectionRow } from '@features/components/CaseOverview/components';
import { reviewStatusNames } from '@/constants/case/case.constants';
import { Case, Review } from '@/api/apis/case';

interface TxCenterServiceApprovalRowProps {
  txCenterServiceApprovalStatus: Case['txCenterServiceApprovalStatus'];
  reviews: Review[];
}

export const TxCenterServiceApprovalRow = ({
  txCenterServiceApprovalStatus,
  reviews,
}: TxCenterServiceApprovalRowProps) => {
  if (!txCenterServiceApprovalStatus) return null;

  const reviewComment = reviews?.find((e: Review) => e.status === txCenterServiceApprovalStatus)?.comment;

  return (
    <ConditionalRender show={!!txCenterServiceApprovalStatus}>
      <SectionRow truncate={false} label="Service Approval by TX Center">
        <div className="flex flex-col gap-1">
          <Chip size="sm">{reviewStatusNames[txCenterServiceApprovalStatus]}</Chip>
          {reviewComment && (
            <Tooltip placement="top" content={reviewComment}>
              <div>
                <Chip size="sm">
                  Сomment: {reviewComment.length > 15 ? `${reviewComment.slice(0, 15)}...` : reviewComment}
                </Chip>
              </div>
            </Tooltip>
          )}
        </div>
      </SectionRow>
    </ConditionalRender>
  );
};
